module.exports = __webpack_public_path__ + "static/hira-a60a5a42fc47b37bc175292474729ad7.jpg";